module.exports = __webpack_public_path__ + "img/40_01_013_445.77a96796.jpg";